export default __webpack_public_path__ + "static/media/single1.426d3d5cbc0cffaf6935c504bea164d2.svg";